import React from 'react';
import StyledDateInterval from "core/components/fields/styledDateInterval";
import {createForm} from 'core/form/createForm';
import StyledSelect from 'core/components/fields/styledSelect';
import NumberField from 'core/components/fields/numberField';
import {Validate} from 'core/form/validate';
import SvgDelete = require('react-icons/lib/md/delete');
import {MdIconButton} from "core/components/buttons/icons";
import {lovLabel, FieldText, FormProps, ClosedContentProps} from 'core/form/formUtils';
import {formatInterval} from "core/common/utils/dateUtils";
import {PriceComponent, Product} from "product/productDomain";
import {observer} from "mobx-react";
import {DomainAncestor} from "core/common/domain/DomainAncestor";
import {BlockComp} from "core/components/blockComp/blockComp";
import ActiveItem from "core/components/blockComp/activeItem";
import {PriceBox} from "product/component/vehicleExpando";
import {action} from "mobx";
import pull = require("lodash/pull");

const ClosedContent = ({dataObject, entity, entities, fields}: ClosedContentProps<PriceComponent>) => (
  <PriceBox pc={dataObject} disableLink priceField={entity.getField("price")} style={{marginRight: 20, minWidth: 100, textAlign: 'center'}} />
);


@createForm({
  formName: 'PriceComponentProductForm',
  nested: true,
  fields: [{
    name: 'price',
    validators: ['IsRequired', 'IsNumber']
  }, {
    name: 'priceCurrency',
    validators: ['IsRequired']
  }, {
    name: 'priceLcy',
    validators: ['IsNumber']
  }, {
    name: 'validFrom'
  }, {
    name: 'validTo'
  }]
}, ClosedContent)
@observer
export default class PriceComponentProductForm extends React.Component<FormProps<PriceComponent, Product>, undefined> {

  @action onDelete = (evt) => {
    evt.stopPropagation();
    console.log('onDelete %o', this.props.dataObject);
    pull(this.props.rootObject.prices, this.props.dataObject);
  };

  render() {

    let {dataObject, rootObject, entities, entity, formName, open} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {price, priceCurrency, priceLcy, validFrom, validTo} = fields;


    const openContent = (
      <div className="row">
        <div className="fx col-xs-6 col-sm-2">
          <NumberField {...price.props} />
          <Validate field={price} value={price.props.value}/>
        </div>
        <div className="fx col-xs-6 col-sm-2">
          <StyledSelect {...priceCurrency.props} />
          <Validate field={priceCurrency} value={priceCurrency.props.value}/>
        </div>
        <div className="fx col-xs-6 col-sm-2">
          <NumberField {...priceLcy.props} />
          <Validate field={priceLcy} value={priceLcy.props.value}/>
        </div>
        <div className="col-xs-6 col-sm-4">
          <StyledDateInterval {...validFrom.props} valueFrom={validFrom.props.value} valueTo={validTo.props.value}
                              onChangeFrom={validFrom.props.onChange} onChangeTo={validTo.props.onChange} />
        </div>
      </div>
    );

    return (
      <BlockComp noPadding style={{marginBottom: 0}}>
      <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />}
                  validate={this.props.validate} onDelete={this.onDelete} {...this.props} closedStyle={{justifyContent: 'initial', paddingTop:5, paddingBottom:5}} />
    </BlockComp>
    );
  }
}




// WEBPACK FOOTER //
// ./src/product/component/priceComponentProductForm.tsx